// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3WZSh","content":"LoadingAlert_content__o7W_q"};